import type { NetBlockDto } from '@terra/shared-contracts-external-network';

type NetblockWhois = NonNullable<NetBlockDto['whois']>;

export function readNetblockWhois({
  raw,
}: {
  raw: Record<string, unknown>;
}): NetblockWhois | null {
  const whois = raw.whois;

  return whois && typeof whois === 'object' ? (whois as NetblockWhois) : null;
}
